module.exports = __webpack_public_path__ + "img/Unidad20-6.4cc4e2f8.png";